var QawafilStoreFrontProducts = (function() {
    'use strict';

    var productDataObj = null;

    function getProductData(){
        return productDataObj;
    }
    function setProductData(productData){
        productDataObj = productData;
    }
    ////////////////////////////// Helper functions /////////////////////
    function checkIfGroupMatchSelection (groupOptions, selectedOptions){
        consoleLog('checkIfGroupMatchSelection:',groupOptions, selectedOptions)
        consoleLog('checkIfGroupMatchSelection: length',groupOptions.length, Object.keys(selectedOptions).length)
        if(Object.keys(selectedOptions).length !== groupOptions.length) return false;
        for (let i = 0; i < groupOptions.length; i++) {
            if(selectedOptions["opt_" + groupOptions[i]['option_id']] != groupOptions[i]['value_id']){
                return false
            }
        }
        return true;
    }

    function updateCardPriceAndQuantityForOptions (productCardWrapper) {
        console.log('updateCardPriceAndQuantity',productCardWrapper )
        let selected_options = {};
        productCardWrapper.find('.product_option_select').each(function() {
            var select = $(this);
            let value_id = select.find('option:selected').attr('data-value-id')
            if (value_id) selected_options["opt_" + select.attr('data-id') ] = value_id;
        });

        let variation_id = null;
        let has_equivalent = false;

        productCardWrapper.find('.product-card-options-variations .variation').each(function(){
            var group = $(this);
            let group_options = JSON.parse(group.attr('data-options'));
            if (checkIfGroupMatchSelection(group_options, selected_options)) {
                console.log('Matched group',group_options)
                has_equivalent = true;
                variation_id = group.attr('data-id');
                productCardWrapper.find('[name=variation_id]').val(variation_id);

                updateCardPriceAndQuantity(productCardWrapper, group);
            }

        });

        if (!has_equivalent) {
            unit_discount_price = 0;
            unit_price = 0;
            productCardWrapper.find('[name=variation_id]').val('');
            // productCardWrapper.find('.disabled_add_btn').removeClass('d-none');
            // productCardWrapper.find('.in_stock_add_btn').addClass('d-none');
            // productCardWrapper.find('.out_of_stock_add_btn').addClass('d-none');
        }
    }

    function updateCardPriceAndQuantity (productCardWrapper, variationDataEl){
        var in_stock = variationDataEl.data('in-stock');
        var unit_price = variationDataEl.data('price');
        var unit_discount_price = variationDataEl.data('discount_price');
        if (unit_price) {
            unit_price = unit_price.toFixed(2);
        }
        if (unit_discount_price) {
            unit_discount_price = unit_discount_price.toFixed(2);
        }

        if(unit_discount_price){
            productCardWrapper.find('.prd-price.prd-price-discount').removeClass('d-none');
            productCardWrapper.find('.prd-price.prd-price-no-discount').addClass('d-none');
            productCardWrapper.find('.prd-price.prd-price-discount .price-new .discount-price').html(unit_discount_price);
            productCardWrapper.find('.prd-price.prd-price-discount .price-old').html(unit_price);
            productCardWrapper.find('.prd-price.prd-price-discount .price-comment .save-amount').html((unit_price - unit_discount_price).toFixed(2));
        }
        else{
            productCardWrapper.find('.prd-price.prd-price-discount').addClass('d-none');
            productCardWrapper.find('.prd-price.prd-price-no-discount').removeClass('d-none');
            productCardWrapper.find('.prd-price.prd-price-no-discount .price-new .price').html(unit_price);
        }

        if (in_stock) {
            productCardWrapper.find('.in_stock_add_btn').removeClass('d-none');
            productCardWrapper.find('.disabled_add_btn').addClass('d-none');
            productCardWrapper.find('.out_of_stock_add_btn').addClass('d-none');
        } else {
            productCardWrapper.find('.in_stock_add_btn').addClass('d-none');
            productCardWrapper.find('.disabled_add_btn').addClass('d-none');
            productCardWrapper.find('.out_of_stock_add_btn').removeClass('d-none');
        }
        return false;
    }

    ////////////////////////////// Helper functions /////////////////////

    // WS-PRV P0: a date that the server sends as a UTC instant (`<time datetime="...Z" data-local-time>`) shows in the
    // customer's own time zone (so the local day is right near midnight), in the page language, with Latin digits.
    // The DATE only, no time (owner), e.g. «26 يوليو 2025». A missing or bad value keeps the server text.
    function formatLocalTimes(root){
        var elements = (root || document).querySelectorAll('[data-local-time]');
        if (!elements.length) return;
        var formatter;
        try {
            formatter = new Intl.DateTimeFormat((document.documentElement.lang || 'ar') + '-u-nu-latn', {dateStyle: 'long'});
        } catch (e) {
            return;
        }
        Array.prototype.forEach.call(elements, function(element){
            var value = element.getAttribute('datetime');
            var date = value ? new Date(value) : null;
            if (!date || isNaN(date.getTime())) return;
            element.textContent = formatter.format(date);
        });
    }

    // WS-PRV P4 — the reviews block and the questions block of an updated theme: sort, star filter and pages of the
    // reviews (the viewer's own review stays on top, never in a page), pages of the questions, and the answer of a send.
    // An old installed copy has no block: nothing here runs for it. Every inserted HTML is the server's Twig output.
    var reviewLists = (function(){
        var state;
        function freshState(){
            return {
                review: {page: 1, sort: 'newest', stars: null, busy: false, shownSort: 'newest', shownStars: null},
                inquiry: {page: 1, busy: false}
            };
        }
        state = freshState();

        function blockOf(type){
            return $(type === 'review' ? '[data-reviews-block]' : '[data-questions-block]').first();
        }
        function listOf(type){
            return $(type === 'review' ? '#comments_list' : '#questions_list');
        }

        function setBusy(type, busy){
            var block = blockOf(type);
            state[type].busy = busy;
            block.attr('aria-busy', busy ? 'true' : 'false');
            block.find('[data-review-sort], [data-review-stars-filter], [data-review-clear], [data-review-stars], [data-load-more]').prop('disabled', busy);
        }

        function setMore(type, hasMore){
            blockOf(type).find('[data-load-more-wrap]').prop('hidden', !hasMore);
        }

        // The toolbar follows the state: the active sort chip, the select, the chip that clears the filter.
        function showToolbar(){
            var block = blockOf('review');
            var review = state.review;
            block.find('[data-review-sort]').each(function(){
                var active = $(this).attr('data-review-sort') === review.sort;
                $(this).toggleClass('is-active', active).attr('aria-pressed', active ? 'true' : 'false');
            });
            var select = block.find('[data-review-stars-filter]');
            select.val(review.stars ? String(review.stars) : '');
            var clear = block.find('[data-review-clear]');
            clear.prop('hidden', !review.stars);
            clear.find('[data-review-clear-text]').text(review.stars ? select.find('option:selected').text() : '');
        }

        // The page's HTML without the items already shown (a new review can shift a page by one).
        function withoutShown(list, html){
            var nodes = $($.parseHTML(html || '', document, false));
            var shown = {};
            list.find('[data-comment-id]').each(function(){ shown[$(this).attr('data-comment-id')] = true; });
            return nodes.filter(function(){
                var id = this.nodeType === 1 ? this.getAttribute('data-comment-id') : null;
                return !id || !shown[id];
            });
        }

        function load(type, page, append){
            var block = blockOf(type);
            var current = state[type];
            if (!block.length || current.busy) return;
            var params = {type: type, page: page, render: 1};
            if (type === 'review') {
                params.sort = current.sort;
                params.stars = current.stars;
                params.exclude_mine = 1;
            }
            setBusy(type, true);
            Qawafil.product.getComments(block.attr('data-product-id'), params, function(response){
                setBusy(type, false);
                var data = response && response.status ? response.data : null;
                if (!data || data.list_html === null || data.list_html === undefined) {
                    // The shown list stays; the toolbar goes back to what the list shows.
                    if (type === 'review') {
                        current.sort = current.shownSort;
                        current.stars = current.shownStars;
                        showToolbar();
                    }
                    toastError(response && response.message ? response.message : undefined);
                    return;
                }
                var list = listOf(type);
                if (append) {
                    list.append(withoutShown(list, data.list_html));
                } else {
                    list.html(data.list_html);
                }
                current.page = page;
                if (type === 'review') {
                    current.shownSort = current.sort;
                    current.shownStars = current.stars;
                    block.find('[data-reviews-empty-filter]').prop('hidden', !(current.stars && !list.find('[data-comment-id]').length));
                }
                setMore(type, !!data.has_more);
                formatLocalTimes(list[0]);
            });
        }

        // A new sort or filter: page 1 again. The state shows at once; a failed request puts it back.
        function reload(sort, stars){
            var review = state.review;
            if (review.busy) return;
            review.sort = sort;
            review.stars = stars;
            showToolbar();
            load('review', 1, false);
        }

        function formWrap(){
            return $('#product_comment_form').closest('[data-review-form-wrap]');
        }

        function openForm(){
            var wrap = formWrap();
            if (!wrap.length) return;
            wrap.prop('hidden', false).removeAttr('data-review-form-closed');
            if (wrap[0].scrollIntoView) wrap[0].scrollIntoView({behavior: 'smooth', block: 'center'});
            // The star radios are hidden in this theme: the text box takes the focus when a star cannot.
            var star = wrap.find('input[name="rating"]:checked, input[name="rating"]').first();
            star.trigger('focus');
            if (!star.length || document.activeElement !== star[0]) wrap.find('textarea[name="comment"]').trigger('focus');
        }

        // The saved review in the form (a second edit starts from it), with the texts of an edit.
        function fillForm(form, saved){
            form.find('input[name="rating"]').prop('checked', false)
                .filter(function(){ return String(this.value) === String(saved.rating); }).prop('checked', true);
            form.find('textarea[name="comment"]').val(saved.text || '');
            // WS-CRS P4: «النجوم فقط» — the form of a saved review has no text field (a first review had one) and shows
            // the saved text read-only (as text, never HTML).
            if (saved.stars_only) starsOnlyForm(form);
            form.find('[data-review-saved-text]').text(saved.text || '');
            form.find('input[type="checkbox"][name="name_style"]').prop('checked', saved.name_style === 'short');
            if (form.attr('data-edit-title')) formWrap().find('[data-review-form-title]').text(form.attr('data-edit-title'));
            if (form.attr('data-save-label')) form.find('[data-review-submit]').text(form.attr('data-save-label'));
        }

        // WS-CRS P4: the text box of the form becomes the read-only text with its hint (the send then has no `comment`).
        function starsOnlyForm(form){
            var box = form.find('textarea[name="comment"]');
            if (!box.length) return;
            var group = box.closest('.form-group');
            group.attr('data-review-stars-only', '');
            group.find('label').removeClass('required');
            group.find('.lev').remove();
            box.replaceWith($('<p class="review-saved-text" dir="auto" data-review-saved-text></p>'));
            var hint = form.attr('data-stars-only-hint');
            if (hint) group.append($('<small class="review-saved-hint d-block"></small>').text(hint));
        }

        function showSaved(form, isReview, response){
            var data = response.data || {};
            var type = isReview ? 'review' : 'inquiry';
            var block = blockOf(type);
            var list = listOf(type);
            toastSuccess(response.message);
            if (!isReview) form[0].reset(); // a question is always a new row

            if (data.list_html === null || data.list_html === undefined) {
                // The server could not render the page: the page shows it after a reload.
                setTimeout(function(){ location.reload(); }, 1500);
                return;
            }

            list.html(data.list_html);
            state[type].page = 1;
            setMore(type, !!data.has_more);

            if (!isReview) {
                formatLocalTimes(list[0]);
                if (list[0] && list[0].scrollIntoView) list[0].scrollIntoView({behavior: 'smooth', block: 'start'});
                return;
            }

            var review = state.review;
            review.sort = review.shownSort = 'newest';
            review.stars = review.shownStars = null;
            showToolbar();
            // The toolbar shows from two shown reviews on: the send may add the second one.
            if (typeof data.shown_count === 'number') block.find('[data-review-toolbar]').prop('hidden', data.shown_count < 2);
            block.find('[data-reviews-empty-filter]').prop('hidden', true);
            if (data.summary_html !== null && data.summary_html !== undefined) {
                block.find('[data-review-summary-slot]').html(data.summary_html);
            }
            var mine = block.find('[data-my-review]');
            mine.html(data.my_review_html || '');
            // WS-CRS P4: a hidden own review is a "saved" card of its author: the page still has no shown review.
            var shownMine = !!data.my_review_html && !(data.my_review && data.my_review.hidden);
            block.find('[data-reviews-empty]').prop('hidden', !!(shownMine || list.find('[data-comment-id]').length));
            if (data.my_review) fillForm(form, data.my_review);
            formatLocalTimes(block[0]);

            var target = list;
            if (data.my_review_html) {
                // The own card came back (WS-CRS P4: also the "saved" card of a review the store hid): the form closes. Its
                // link «تعديل تقييمك» shows only while one more edit is allowed (after the one edit it does not).
                formWrap().prop('hidden', true).attr('data-review-form-closed', '');
                target = mine;
            }
            if (target[0] && target[0].scrollIntoView) target[0].scrollIntoView({behavior: 'smooth', block: 'start'});
        }

        // One page, one start: the lists as the server rendered them (page 1, newest, no filter).
        function init(){
            state = freshState();
            var reviews = blockOf('review');
            var questions = blockOf('inquiry');
            if (reviews.length) {
                reviews.on('click', '[data-review-sort]', function(){
                    reload($(this).attr('data-review-sort'), state.review.stars);
                });
                reviews.on('change', '[data-review-stars-filter]', function(){
                    var stars = parseInt($(this).val(), 10);
                    reload(state.review.sort, stars >= 1 && stars <= 5 ? stars : null);
                });
                // A bar of the summary sets the same filter (only where the toolbar can clear it).
                reviews.on('click', '[data-review-stars]', function(){
                    if (!reviews.find('[data-review-toolbar]:not([hidden])').length) return;
                    var stars = parseInt($(this).attr('data-review-stars'), 10);
                    reload(state.review.sort, stars >= 1 && stars <= 5 ? stars : null);
                });
                reviews.on('click', '[data-review-clear]', function(){
                    reload(state.review.sort, null);
                });
                reviews.on('click', '[data-load-more]', function(){
                    load('review', state.review.page + 1, true);
                });
            }
            if (questions.length) {
                questions.on('click', '[data-load-more]', function(){
                    load('inquiry', state.inquiry.page + 1, true);
                });
            }
            // «تعديل تقييمك» of the own review opens the closed form (the card is replaced after a send).
            $(document).off('click.reviewEdit').on('click.reviewEdit', '[data-review-edit]', function(e){
                e.preventDefault();
                openForm();
            });
        }

        return {init: init, blockOf: blockOf, showSaved: showSaved};
    })();

    function registerProductDetailsEvents(){

        formatLocalTimes(document);

        // share product
        var fbButton = document.getElementById('fb-share-button');
        if(fbButton){
            var url = fbButton.getAttribute('data-href');
            fbButton.addEventListener('click', function() {
                window.open('https://www.facebook.com/sharer/sharer.php?u=' + url,
                    'facebook-share-dialog',
                    'width=800,height=600'
                );
                return false;
            });
        }


        // product comments (questions and reviews)
        $('.tap-link').click(function(e){
            e.preventDefault();
            let tapsWrapper = $(this).closest('.taps-container');
            let tapContentSelector =  $(this).attr('href');

            // hide all taps
            tapsWrapper.find('.tap-content').hide();
            tapsWrapper.find('a.tap-link').parent('li').removeClass('active')

            // show clicked tap
            tapsWrapper.find(tapContentSelector).show();
            $(this).parent('li').addClass('active');
        });

        // WS-PRV P0: the button is locked until the answer arrives; a saved comment clears the form and shows the new
        // list at once (the server renders it with the shop's own comment card, so no HTML is built here).
        $('#product_question_form, #product_comment_form').submit(function(e){
            e.preventDefault();
            let form = $(this);
            let submitButton = form.find('[type=submit]');
            if (submitButton.prop('disabled')) return;
            submitButton.prop('disabled', true);

            let formData = new FormData(form[0]);
            let body = QawafilStoreFront.helpers.getFormDataAsObject(formData);
            Qawafil.product.addComment(body, function(response){
                submitButton.prop('disabled', false);
                if(response){
                    if (response.status) showSavedComment(form, response);
                    else if (response.code !== 403 && response.code !== 401) toastError(response.message);
                }
                else{
                    toastError();
                }

            });
        });

        function showSavedComment(form, response){
            let data = response.data || {};
            let isReview = form.attr('id') === 'product_comment_form';
            let list = $(isReview ? '#comments_list' : '#questions_list');

            // WS-PRV P4: the answer of a send from the new block (`list=paged`) carries `has_more`.
            if (reviewLists.blockOf(isReview ? 'review' : 'inquiry').length && data.has_more !== undefined) {
                reviewLists.showSaved(form, isReview, response);
                return;
            }

            form[0].reset();
            toastSuccess(response.message);

            if (data.list_html === null || data.list_html === undefined) {
                // The server could not render the list: the page shows it after a reload.
                setTimeout(function(){ location.reload(); }, 1500);
                return;
            }
            list.html(data.list_html);
            formatLocalTimes(list[0]);
            if (isReview && data.badge_html) {
                // The stars badge of the reviews block: the direct child of the block that holds the list.
                list.parent().children('.prd-rating').first().replaceWith(data.badge_html);
            }
            if (list[0] && list[0].scrollIntoView) list[0].scrollIntoView({behavior: 'smooth', block: 'start'});
        }

        reviewLists.init();

        // product description expand/collapse
        const container = document.getElementById("prd-desc-container");
        const button = document.getElementById("toggle-desc-btn");
        const showMoreBtn = document.getElementById("show-more-desc-btn");
        const showLessBtn = document.getElementById("show-less-desc-btn");

        if(container && button && showMoreBtn && showLessBtn) {
            // Set the initial max-height dynamically based on the actual content
            const initialMaxHeight = 350; // You can adjust this
            container.style.maxHeight = initialMaxHeight + "px";

            // Show button only if content is overflowing
            if (container.scrollHeight > initialMaxHeight) {
                button.classList.remove("d-none");
            }

            button.addEventListener("click", function () {
                if (container.style.maxHeight === initialMaxHeight + "px") {
                    container.style.maxHeight = container.scrollHeight + "px"; // Expand fully
                    showMoreBtn.classList.add("d-none");
                    showLessBtn.classList.remove("d-none");
                } else {
                    container.style.maxHeight = initialMaxHeight + "px"; // Collapse back
                    showMoreBtn.classList.remove("d-none");
                    showLessBtn.classList.add("d-none");
                }
            });
        }


    }


    function registerAddToCartEvents(productData){
        var unit_price = productData.price;
        var unit_discount_price = productData.discount_price;

        function refreshProductMedia (mediaList) {

            if (mediaList.length <= 0) {
                mediaList = productData.media;
            }
            consoleLog('refreshProductMedia', mediaList);
            try {
                if (mediaList.length > 0) {
                    $('.product-previews-carousel').slick('slickRemove');
                    $('.product-previews-carousel .slick-slide').each(function () {
                        $('.product-previews-carousel').slick('slickRemove', 0)
                    });
                    mediaList.forEach(function (row) {
                        $('.product-previews-carousel').slick('slickAdd', `
                        <a href="#"
                            data-image="${row.media.url}"
                            data-zoom-image="${row.media.url}">
                            <img src="${row.medium_media.url}" alt="">
                        </a>
                    `);
                    });

                    $('.js-prd-gallery .js-main-image--slide img').attr('src', mediaList[0].media.url);
                    $('.js-prd-gallery .js-main-image--slide img').attr('data-zoom-image', mediaList[0].media.url);
                    $('.product-previews-carousel').slick('slickGoTo', 0, true);
                    $('.product-previews-carousel').slick('refresh');
                    $('.product-previews-carousel').find('.slick-current').trigger('click');

                }
            } catch (error) {
                consoleLog(error)
            }


        }
        function updatePriceAndMaxQuantity () {
            let selected_options = {};
            let max_quantity = 1;
            let has_equivalent = false;

            productData.options.forEach(option => {
                // if (option.type_id === select) {
                var value_id = $('#option_' + option.id).find('option:selected').attr('data-value-id')
                if (value_id) selected_options["opt_" + option.id ] = value_id;
                // }
            });
            for (var i = 0; i < productData.variations.length; i++) {

                var variation = productData.variations[i];
                if (checkIfGroupMatchSelection(variation.group_data, selected_options)) {

                    refreshProductMedia(variation.media);
                    has_equivalent = true;
                    $('#variation_id').val(variation.id);
                    max_quantity = variation.unlimited_quantity ? /* 100 */ null : variation.quantity;
                    unit_price = variation.price;
                    unit_discount_price = variation.discount_price;

                    console.log('updatePriceAndMaxQuantity:max_quantity,unit_price,unit_discount_price', max_quantity,unit_price,unit_discount_price)
                    if (unit_price) {
                        unit_price = unit_price.toFixed(2);
                    }
                    if (unit_discount_price) {
                        unit_discount_price = unit_discount_price.toFixed(2);
                    }

                    $('#prices_container').html(`
                        ${unit_discount_price != null ?
                                `<div class="prd-block_price">
                                            <span class="prd-block_price--actual" >
                                                <span id="product_discount_price">${unit_discount_price}</span>
                                                <span>${QawafilStoreFront.helpers.getCurrencyIconHtml()}</span></span>
                                            <span class="prd-block_price--old" id="product_actual_price" >${unit_price}</span>
                                        </div>`

                                :
                                `<div class="prd-block_price">

                                            <span class="prd-block_price--actual" >  <span id="product_actual_price">${unit_price}</span>  <span>${QawafilStoreFront.helpers.getCurrencyIconHtml()}</span></span>
                                        </div>`
                            }
                    `);
                    // $('.original_price').text(price);
                    $('#quantity').attr('data-max', max_quantity);
                    $('#quantity').attr('data-min', max_quantity === 0 ? 0 : 1);

                    $('#quantity').val(max_quantity === 0 ? 0 : 1);

                    if (max_quantity == 0) {
                        $('#btn_add_cart').attr('disabled', true);
                        $('#out_of_stock_text').show();
                        $('#add1').attr('disabled', true);
                        $('#minus1').attr('disabled', true);
                    } else {
                        $('#btn_add_cart').attr('disabled', false);
                        $('#out_of_stock_text').hide();
                        $('#add1').attr('disabled', false);
                        $('#minus1').attr('disabled', false);
                    }
                    return false;
                }


            }

            if (!has_equivalent) {
                refreshProductMedia([]);
                unit_discount_price = 0;
                unit_price = 0;
                $('#btn_add_cart').attr('disabled', true);
                $('#out_of_stock_text').show();
                $('#add1').attr('disabled', true);
                $('#minus1').attr('disabled', true);
                $('#variation_id').val(null);
            }
        }

        function updateProductPricePreviewOnUpdateQuantity (type = null, input_quantity = 0) {
            let max_quantity = parseInt($('#quantity').attr('data-max'));
            let min_quantity = parseInt($('#quantity').attr('data-min'));
            let q = 0;
            if (input_quantity) {
                q = input_quantity;
            } else {
                let q_val = parseInt($('#quantity').val());
                if (type == 'add') {
                    q = q_val + 1;
                } else if (type == 'minus') {
                    q = q_val - 1;
                }
            }

            if (q > max_quantity) {
                q = max_quantity;
                $('#quantity').val(q);
            } else if (q < min_quantity) {
                q = min_quantity;
                $('#quantity').val(q);
            }

            console.log('q: '+ q);

            if (q == 0) {
                return;
            }

            let dp = $('#product_discount_price');
            let p = $('#product_actual_price');

            try {
                p.text((q * unit_price).toFixed(2));
                dp.text((q * unit_discount_price).toFixed(2));

                let price = q * unit_price;

                if (unit_discount_price) {
                    price = q * unit_discount_price;
                }
                console.log('price: '+ price);

                displayTamaraProductWidget(price);
                displayTabbyProductSnippet(price);

            } catch (error) {
                console.log('error: '+ error);
                p.text((q * unit_price).toFixed(2));

            }

        }

        setTimeout(function () {
            productData.options.forEach(option => {
                // if (option.type_id === select) {
                $('#option_' + option.id).on('change', function () {
                    updatePriceAndMaxQuantity($('#option_' + option.id));
                });
                $('#option_' + option.id).prop("selectedIndex", 1).trigger('change');
                // }
            });
        }, 1);

        $('#btn_add_cart').on('click', function (e) {
            if ($('#quantity').val() > 0) {
                let qty = $('#quantity').val() ? $('#quantity').val() : 1;
                let variationId = $('#variation_id').val();
                // format custom fields
                let customFields = {};
                // Check if the 'note' field is visible and collect its value
                var note = $('[name="custom_fields[note]"]').val();
                if (note) customFields['custom_fields[note]'] = note;
                // Check if the 'file' field is visible and collect the file
                var file = $('[name="custom_fields[file]"]').length ? $('[name="custom_fields[file]"]')[0].files[0] : null; // Get the first file if there is one
                if (file) customFields['custom_fields[file]'] = file;

                QawafilStoreFrontCart.addCartItem(productData.id, qty,variationId, customFields);
            } else {
                toastError('يجب أن تكون الكمية أكبر من صفر');
            }
        });

        $('#add1').on('click', function (e) {
            updateProductPricePreviewOnUpdateQuantity('add');
        });

        $('#minus1').on('click', function (e) {
            updateProductPricePreviewOnUpdateQuantity('minus');
        });

        $('#quantity').on('input', function (e) {

            if ($('#quantity').val()) {
                if (/^\d+$/.test($('#quantity').val())) {
                    updateProductPricePreviewOnUpdateQuantity(null, $('#quantity').val());
                }
                else {
                    $('#quantity').val($('#quantity').attr('data-min'));
                }
            }
        });

        QawafilStoreFront.helpers.preventOnEnter('#cart-form');
    }


    function initProductDetailsPage (productData){
        setProductData(productData);
        registerAddToCartEvents(productData)
        registerProductDetailsEvents();
    }

    function initProductCardEvents() {

        $(document).on('click', '.btn_quick_add_cart',  function (e) {
            let productId = $(this).attr('data-prd-id');
            var variationId = null;
            var variationIdInput = $(this).closest('.prd').find('[name=variation_id]');
            if(variationIdInput.length){
                variationId = variationIdInput.val();
                if(!variationId) {
                    toastError('يرجى تحديد خيار المنتج المراد إضافته');
                    return false;
                }
            }
            QawafilStoreFrontCart.addCartItem(productId, 1, variationId);
        });
        initProductCardOptions();
    }



    function initProductFilterPage (){
        function registerProductFilterEvents(){
            var lastProductsScrollTop = $(window).height();
            var productsLoader = $('#products-grid-section #products_loader');
            var emptyContentEl = $('#products-grid-section #product_filter_empty_content');
            var productsContainerEl = $('#products-grid-section #products_container');
            var loadProductsOnScroll = productsContainerEl.data('load-products-on-scroll');
            var nextProductsUrl = productsContainerEl.data('next-url');
            var categoryId = productsContainerEl.data('category-id');
            var loadingProducts = false;

            if(loadProductsOnScroll){
                $(window).scroll(function (event) {
                    var st = $(this).scrollTop();
                    if (st > lastProductsScrollTop) {
                        lastProductsScrollTop = st;
                        // consoleLog(nextUrl, loading, (nextUrl && (loading === false)))
                        if (nextProductsUrl && (loadingProducts === false)) {
                            filterProducts(nextProductsUrl);
                        }
                    } else {
                        // upscroll code
                    }
                });
            }
            else{
                $(document).on('click','#products-grid-section .pagination .page-link', function(e){
                    e.preventDefault();
                    filterProducts($(this).attr('href'));
                });
            }

            var filterProducts = function(url=null) {
                let formFilters = $('#form-filter-products').serialize();
                let perPage = $('[name="per_page"]').val();
                let filterUrl = url;
                if(url == null){
                    let pagePath = categoryId ?  '/categories/' +categoryId : '/search';
                    filterUrl = Qawafil.getShopUrl() + pagePath + '?per_page=' + perPage + '&'+formFilters;
                }

                if(loadProductsOnScroll){
                    loadingProducts = true;
                    productsLoader.removeClass('d-none');
                }
                if(!loadProductsOnScroll || url== null) {
                    QawafilStoreFront.helpers.blockPage();
                    productsLoader.addClass('d-none');
                }

                $.get(filterUrl, function(response){

                    $('#products_count').html(jQuery(response).find('#products_count').html());

                    if(loadProductsOnScroll){
                        if( url == null) productsContainerEl.empty();
                        nextProductsUrl =  jQuery(response).find('#products_container').data('next-url');
                        productsContainerEl.append(jQuery(response).find('#products_container').html());

                        if(productsContainerEl.children().length > 0) emptyContentEl.addClass('d-none');
                        else emptyContentEl.removeClass('d-none');

                        loadingProducts = false;
                        productsLoader.addClass('d-none');
                    }
                    else{
                        $('#products-grid-section').html(jQuery(response).find('#products-grid-section').html());
                    }
                    QawafilStoreFront.helpers.unBlockPage();
                    initProductCardOptions ();

                });
            }

            QawafilStoreFront.helpers.preventOnEnter('#form-filter-products');

            $('#form-filter-products input').change(function(){

                if($(this).attr('name') == 'search_query') return;
                if($(this).attr('name') == 'search-datepicker' && $(this).attr('data-selecting') === "true") return;

                filterProducts();
            });

            $('#form-filter-products input').on('keypress',  function (event) {

                var keycode = (event.keyCode ? event.keyCode : event.which);
                if (keycode == '13') {
                    event.preventDefault();
                    filterProducts();
                }
            });

            $('#products-grid-aside [name="per_page"]').change(function(){
                filterProducts();
            });
        }

        registerProductFilterEvents();
    }

    function initProductCardOptions (){

        $('.product-card-options .product_option_select').each(function() {
            var selectEl = $(this);
            console.log('handle select option', selectEl)
            selectEl.on('change', function () {
                updateCardPriceAndQuantityForOptions(selectEl.closest('.prd'));
            });
        });
        $('.product-card-options .product_variation_select').each(function() {
            var selectEl = $(this);
            selectEl.on('change', function () {
                var productCardWrapper = selectEl.closest('.prd');
                var selectedOption = productCardWrapper.find('.product_variation_select').children('option:selected');
                updateCardPriceAndQuantity(productCardWrapper, selectedOption);
            });
        });
    }
    return {
        initProductDetailsPage: initProductDetailsPage,
        formatLocalTimes: formatLocalTimes,
        // WS-PRV P4: the reviews block (its tests drive it directly).
        reviewLists: reviewLists,
        initProductFilterPage: initProductFilterPage,
        initProductCardEvents:initProductCardEvents,
        initProductCardOptions: initProductCardOptions,
        getProductData:getProductData
    };

})();
